<template>
  <HeadingLv1 text="会員退会手続き" />
  <div class="u-containar">
    <div style="margin-bottom:30px;">
    内容を確認してください。退会を希望される方は「退会」ボタンをクリックしてください。
    </div>

    <div>
    退会理由をお聞かせください<br>
    <div> {{ answer_comment }}</div>
    <hr>
    </div>

    <form v-on:submit="$router.push('/mypage/leave/thanks')">
    <input type="hidden" name="_token" :value="csrf" />

    <div class="buttons">
      <Button
        label="戻る"
        :handleClick="
          () => {
            this.$router.go(-1)
          }
        "
      />
      <Button
        label="退会する"
        :handleClick="confirm"
        primary
      />
    </div>
    </form>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, ref } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  props: {
    answer: Number,
    answer_comment: String,
  },

  name: 'MypageLeaveInput',

  components: {
    Button,
    HeadingLv1,
  },

  setup(props: any) {
    const store = useStore()
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    const confirm = () => {
        const ajax = axiosSetting('app', 'action')

        const params: any = {
          unsub_reason_id: props.answer,
          _token: csrf.value,
          token: state.token,
        }

        ajax
          .post('/api/v1/user_leave/unsub', params)
          .then((res) => {
            const ajax = axiosSetting('app', 'action')
            ajax
              .get('/logout?home=true')
              .then((res) => {
                console.log("logout success");
                store.commit('resetUserInfo');
                //router.replace('/mypage/leave/thanks');
                window.location.href = '/mypage/leave/thanks';
              })
              .catch((errors: any) => {
                console.log("logout error");
                store.commit('resetUserInfo');
                //router.replace('/mypage/leave/thanks');
                window.location.href = '/mypage/leave/thanks';
              })
          })
          .catch((errors: any) => {
            if (errors.response.data) {

              const errorInfo = errors.response.data
              Object.keys(errorInfo).forEach((key) => {
                // リダイレクト（パスワードが空の場合)
                if (key == 'redirect') {
                  // TODO: メッセージ追加
                  // リダイレクトする
                  router.push(errorInfo[key]);
                } else if (key == 'alert') {
                  alert(errorInfo[key]);
                }

              })
            }
          })
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')

      if (props.answer == null) {
        router.push('/');
      }
    })

    return {
      csrf,
      state,
      FormSelectField,
      confirm,
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.reqBtn {
  @include mixins.media() {
    .button {
      margin-right: 0;
    }
  }
}

::v-deep(.headingLv2) {
  margin-top: 50px;
  margin-bottom: 35px;

  & + .button {
    max-width: 88%;
  }
}

.fixedArea {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  z-index: 100;
  height: 72px;
  background: #fff;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fixedArea .button {
  margin-left: 8px;
  margin-right: 8px;
  max-width: 224px;

  &:first-child {
    flex-shrink: 2;
  }

  &:last-child {
    flex-grow: 1;
  }
}

// ::v-deep(.goalButtons) {
//   position: fixed;
//   bottom: 55px;
//   width: 100%;
//   padding-right: 15px;
//   padding-left: 15px;
//   background: #fff;
//   z-index: 100;
// }

// .fixedArea

// ::v-deep(.goalButtons .button) {
//   max-width: none;
//   flex-basis: 85px;
//   flex-grow: 0;
//   width: auto;
// }

// ::v-deep(.goalButtons .button.primary) {
//   flex-grow: 1;
// }
.buttons {
  display: flex;
  justify-content: center;
  margin: 45px -16px 0;
  padding: 10px 8px;
  background-color: #f5f5f5;

  @include mixins.media() {
    margin: 70px 0 0;
    background-color: transparent;
  }

  .button {
    margin: 0 4px;

    @include mixins.media() {
      margin: 0 8px;
    }
  }
}
</style>
